module.exports = __webpack_public_path__ + "media/U_talk.03a792d6.mp3";